export enum PROJECT_MANAGEMENT_STATUS_ENUM {
  DRAFT = 'DRAFT',
  RUNNING = 'RUNNING',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  ON_HOLD = 'ON_HOLD',
}

export enum PROJECT_MANAGEMENT_REFERENCE_SECTION {
  PROJECT_MANAGEMENT = 'PROJECT MANAGEMENT',
}

export enum PROJECT_MANAGEMENT_REFERENCE_CATEGORIES {
  CATEGORIES = 'PROJECT CATEGORIES',
  INDUSTRIES = 'INDUSTRIES',
}

export enum PROJECTS_REFERENCE_CATEGORY_FIELD {
  NAME = 'NAME',
}

export const PROJECT_ACTIONS = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  VIEW_INSIGHTS: 'VIEW_INSIGHTS',
  STATUS_CHANGES: 'STATUS_CHANGES',
  RESTORE: 'RESTORE',
};

export enum STATUS_CHANGE {
  COMPLETED = 'Completed',
  RUNNING = 'Running',
  ON_HOLD = 'On Hold',
  EXPIRED = 'Expired',
}

export enum PROJECT_TABS {
  OVERVIEW = 'OV',
  TASKS = 'TA',
  BOARD = 'BO',
  TEAM = 'TE',
  REPORTS = 'RE',
  LINKS = 'LI',
  DOCUMENTS = 'DOC',
}
